import ZJApp from '../../../../app'

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
    service: 'UniformAuthService',
    controller: 'MenuInfo'
}
const methods = [
    'AddItem',
    'UpdateItem',
    'DelItem',
    'GetItemById',
    'GetItemByMenuId',
    'GetItemByMenuCode',
    'FindByConditions',
    'GetPageContentByConditions',
    'FindLastMenuIndexByParentMenuId'
]

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
}

const MenuApi = ZJApi.defineNewApi('MenuApi', factory)

export default MenuApi